import { useCookies } from '@packages/shared/src/providers/CookieProvider/CookieProvider';

import { getDefaultPageSize } from '../utils/getDefaultPageSize';

export const useDefaultPageSize = () => {
  const { getCookies } = useCookies();

  return getDefaultPageSize(getCookies());
};
